import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { orderInfoStyle } from "@rugby/App/WidgetExtensions/MyAccountPagesSharedStyle/DetailsPage.style";
import React, { FC, useContext } from "react";

export interface OrderDetailsShipCompleteStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    status?: TypographyProps;
}

export const shipCompleteStyles: OrderDetailsShipCompleteStyles = {
    wrapper: orderInfoStyle.orderWrapper,
    titleText: orderInfoStyle.orderLabel,
    status: orderInfoStyle.orderValue,
};

const styles = shipCompleteStyles;

const OrderDetailsShipComplete: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.properties.orderShipComplete) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsShipComplete">
                {translate("ShipComplete")}
            </Typography>
            <Typography {...styles.status} aria-labelledby="orderDetailsShipComplete">
                {order.properties.orderShipComplete.toLowerCase() === "false" ? "No" : "Yes"}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsShipComplete,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
